import { render, staticRenderFns } from "./ScreeningsUpdateProfileImages.vue?vue&type=template&id=236b54e6&scoped=true&"
import script from "./ScreeningsUpdateProfileImages.vue?vue&type=script&lang=js&"
export * from "./ScreeningsUpdateProfileImages.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningsUpdateProfileImages.vue?vue&type=style&index=0&id=236b54e6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236b54e6",
  null
  
)

export default component.exports